var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box flex-center-center flex-col"},[(_vm.text)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.textSmall)?_c('div',{staticClass:"text-small"},[_vm._v(_vm._s(_vm.textSmall))]):_vm._e(),_c('img',{staticClass:"img",attrs:{"src":require("@/assets/error/404.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }